import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import CustomTooltip from '../CustomTooltip';
import useTooltip from '../hooks/useTooltip';

interface ISimpleChipsCellProps {
  data: string;
  align?: string;
}

function SimpleChipsCell({ data, align = 'center' }: ISimpleChipsCellProps) {
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } = useTooltip();
  const { formatMessage: f } = useIntl();

  const handleLabelClass = (value: string) => {
    switch (value) {
      case 'current':
        return 'e-table-label--success';
      case 'locked':
        return 'e-table-label--error';
      case 'unlocked':
        return 'e-table-label--success';
      default:
        return 'e-table-label--info';
    }
  };

  const handleIconClass = (value: string) => {
    switch (value) {
      case 'current':
        return 'cmd-icon-active';
      case 'locked':
        return 'cmd-icon-lock';
      case 'unlocked':
        return 'cmd-icon-unlock';
      default:
        return 'cmd-icon-hourglass';
    }
  };

  const handleText = (value: string) => {
    switch (value) {
      case 'current':
        return f({ id: 'enum.periodLocks.status.current' });
      case 'locked':
        return f({ id: 'enum.periodLocks.status.locked' });
      case 'unlocked':
        return f({ id: 'enum.periodLocks.status.unlocked' });
      default:
        return f({ id: 'enum.periodLocks.status.waiting' });
    }
  };

  const tooltipContent = (value: string) => {
    switch (value) {
      case 'current':
        return f({ id: 'enum.periodLocks.status.tooltip.current' });
      case 'locked':
        return f({ id: 'enum.periodLocks.status.tooltip.locked' });
      case 'unlocked':
        return f({ id: 'enum.periodLocks.status.tooltip.unlocked' });
      default:
        return f({ id: 'enum.periodLocks.status.tooltip.waiting' });
    }
  };

  return (
    <div
      className={`text-cell align-${align}`}
      style={{ flex: 1 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CustomTooltip content={tooltipContent(data)} show={hover} position={tooltipPos}>
        <div className={`e-table-label ${handleLabelClass(data)}`} ref={textRef}>
          <i className={`cmd-icon ${handleIconClass(data)}`} />
          {handleText(data)}
        </div>
      </CustomTooltip>
    </div>
  );
}

export default SimpleChipsCell;
